import { render, staticRenderFns } from "./SetupLP360DesktopDialog.vue?vue&type=template&id=5e22532a&scoped=true&"
import script from "./SetupLP360DesktopDialog.vue?vue&type=script&lang=ts&"
export * from "./SetupLP360DesktopDialog.vue?vue&type=script&lang=ts&"
import style0 from "./SetupLP360DesktopDialog.vue?vue&type=style&index=0&id=5e22532a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e22532a",
  null
  
)

export default component.exports